import { useContext } from 'react'
import { StatsStore } from './types'
import { useStore } from 'zustand'
import { StatsContext } from './provider'

export function useStats<T>(selector: (store: StatsStore) => T): T {
  const ctx = useContext(StatsContext)

  if (ctx === undefined) {
    throw new Error('Stats selector must be used within StatsProvider')
  }

  return useStore(ctx, selector)
}
